export const NAVIGATION_IDS = {
  ALLOWLIST_UPLOAD_SOV: 'allowlist-upload-sov',
  ALLOWLIST_UPLOAD_CATEGORY: 'allowlist-upload-category',
  ALLOWLIST_UPLOAD_TYPE_OF_PURCHASE: 'allowlist-upload-type-of-purchase',
  ALLOWLIST_UPLOAD_ADVERTISERS: 'allowlist-upload-advertisers',
  ALLOWLIST_UPLOAD_AE: 'allowlist-upload-ae',
  USERS: 'users',
  EDIT_INVENTORY: 'edit-inventory',
  BOOKINGS: 'bookings',
  ROLES: 'roles',
  ALLOWLIST: 'allowlist',
  EDIT_ART_EVENT: 'edit-art-event',
  DASHBOARD: 'dashboard'
} as const;

export const FROZEN_DISABLED_NAVIGATION_IDS = [
  NAVIGATION_IDS.ALLOWLIST_UPLOAD_SOV,
  NAVIGATION_IDS.ALLOWLIST_UPLOAD_CATEGORY,
  NAVIGATION_IDS.ALLOWLIST_UPLOAD_TYPE_OF_PURCHASE,
  NAVIGATION_IDS.EDIT_INVENTORY,
] as const;
